import Container from "../Container";
import React from "react";
import Spacer from "../Spacer";

export interface StatisticsShowcaseProps {
  data: {
    className?: string;
    title: string;
    value: number | string;
    description: string;
  }[];
}

const StatisticsShowcase = ({ data }: StatisticsShowcaseProps) => {
  return (
    <Container>
      <Spacer>
        <div className="flex flex-wrap justify-center lg:flex-no-wrap">
          {data.map((item, key) => (
            <div
              className={`w-full ${
                key !== data.length - 1 ? "lg:border-r" : ""
              }`}
              key={key}
            >
              <div className="flex flex-col flex-wrap items-center justify-center py-6 text-center">
                <div className="text-5xl font-bold">
                  <div className={item.className}>{item.value}</div>
                </div>
                <div className="m-0">{item.title}</div>
                <div className="max-w-xs px-6 mx-auto mt-2 text-xs text-gray-400">
                  {item.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Spacer>
    </Container>
  );
};

export default StatisticsShowcase;
